var map = {
	"./": 319,
	"./LiveStream.module.scss": 343,
	"./LiveStreamDeferred": 1144,
	"./LiveStreamDeferred.tsx": 1144,
	"./actions": 74,
	"./actions.ts": 74,
	"./components/MatchesDropdown": 301,
	"./components/MatchesDropdown/": 301,
	"./components/MatchesDropdown/DropdownComponents": 371,
	"./components/MatchesDropdown/DropdownComponents.tsx": 371,
	"./components/MatchesDropdown/MatchesDropdown.dictionary": 171,
	"./components/MatchesDropdown/MatchesDropdown.dictionary.json": 171,
	"./components/MatchesDropdown/MatchesDropdown.module.scss": 254,
	"./components/MatchesDropdown/index": 301,
	"./components/MatchesDropdown/index.tsx": 301,
	"./components/MatchesDropdown/sport-utils": 372,
	"./components/MatchesDropdown/sport-utils.ts": 372,
	"./components/Players": 975,
	"./components/Players/": 975,
	"./components/Players/HLSHandler": 1042,
	"./components/Players/HLSHandler.tsx": 1042,
	"./components/Players/Twitch/TwitchHandler": 1043,
	"./components/Players/Twitch/TwitchHandler.module.scss": 1109,
	"./components/Players/Twitch/TwitchHandler.tsx": 1043,
	"./components/Players/Twitch/global.d": 1145,
	"./components/Players/Twitch/global.d.ts": 1145,
	"./components/Players/YouTubeHandler": 1044,
	"./components/Players/YouTubeHandler.tsx": 1044,
	"./components/Players/index": 975,
	"./components/Players/index.ts": 975,
	"./components/ToolbarButtons": 303,
	"./components/ToolbarButtons/": 303,
	"./components/ToolbarButtons/ToolbarButtons.dictionary": 373,
	"./components/ToolbarButtons/ToolbarButtons.dictionary.json": 373,
	"./components/ToolbarButtons/index": 303,
	"./components/ToolbarButtons/index.tsx": 303,
	"./components/ToolbarControls": 302,
	"./components/ToolbarControls/": 302,
	"./components/ToolbarControls/ToolbarControls.dictionary": 374,
	"./components/ToolbarControls/ToolbarControls.dictionary.json": 374,
	"./components/ToolbarControls/index": 302,
	"./components/ToolbarControls/index.tsx": 302,
	"./constants": 212,
	"./constants.ts": 212,
	"./index": 319,
	"./index.tsx": 319,
	"./local-storage-helpers": 253,
	"./local-storage-helpers.ts": 253,
	"./records": 170,
	"./records.ts": 170,
	"./reducer": 295,
	"./reducer/": 295,
	"./reducer/entries": 350,
	"./reducer/entries.ts": 350,
	"./reducer/index": 295,
	"./reducer/index.ts": 295,
	"./saga": 360,
	"./saga.ts": 360,
	"./selectors": 96,
	"./selectors.ts": 96,
	"./types": 1022,
	"./types/": 1022,
	"./types/backend/liveStream": 1146,
	"./types/backend/liveStream.ts": 1146,
	"./types/index": 1022,
	"./types/index.ts": 1022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1273;
module.exports = webpackContext;